module.exports = __webpack_public_path__ + "static/media/clue0303.fe4c1f5f.jpg";